/**
 * Handles article slideshows and outro listing slideshows
 */

class ArticleSlideshow extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('.image-slide-block');
    this.dots = this.querySelectorAll('.slide-dot');
    this.slideItems = this.querySelectorAll('.slider__slide');

    if (!this.slider || this.slideItems.length <= 1) return;

    this.currentSlide = 0;
    this.setupObservers();
    this.setupEventListeners();
    
    // Set first dot as active by default
    if (this.dots.length > 0) {
      this.dots[0].classList.add('active');
    }
  }

  setupObservers() {
    const options = {
      root: this.slider,
      threshold: 1
    };

    /*
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const slideIndex = Array.from(this.slideItems).indexOf(entry.target);
          this.updateActiveDot(slideIndex);
          this.currentSlide = slideIndex;
        }
      });
    }, options);
    */
    const activeSlides = new Array();
    this.slideItems.forEach(() => {
      activeSlides.push(false);
    })

    let slideItemsArray = Array.from(this.slideItems);
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        activeSlides[slideItemsArray.indexOf(entry.target)] = entry.isIntersecting;
      })
      for (let i = 0; i < activeSlides.length; i++){
        if (activeSlides[i]) {
          this.updateActiveDot(i);
          this.currentSlide = i;
          break;
        } 
      }
    },options);

    this.slideItems.forEach(slide => {
      this.observer.observe(slide);
    });
  }

  setupEventListeners() {
    // Setup dot navigation
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        this.goToSlide(index);
      });
    });
    
    // Add keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.goToSlide(Math.max(0, this.currentSlide - 1));
      } else if (e.key === 'ArrowRight') {
        this.goToSlide(Math.min(this.slideItems.length - 1, this.currentSlide + 1));
      }
    });
  }

  updateActiveDot(index) {
    // Remove active class from all dots
    this.dots.forEach(dot => {
      dot.classList.remove('active');
    });
    
    // Add active class to current dot
    if (this.dots[index]) {
      this.dots[index].classList.add('active');
    }
  }

  goToSlide(index) {
    if (index < 0 || index >= this.slideItems.length) return;
    
    this.slideItems[index].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest',
      inline: 'start'
    });
    
    this.updateActiveDot(index);
    this.currentSlide = index;
  }
}

class OutroSlideshow extends HTMLElement {
  constructor() {
    super();
    this.id = this.getAttribute('id') || `outro-slideshow-${new Date().getTime()}`;
    this.slider = this.querySelector('._slideshow');
    this.dots = Array.from(this.querySelectorAll('.slide-dot'));
    this.slideItems = Array.from(this.querySelectorAll('.slider__slide'));

    if (!this.slider || this.slideItems.length <= 1 || this.querySelector('.-list')) return;

    this.currentSlide = 0;
    this.initSlideshow();
  }

  initSlideshow() {
    // Set first dot as active by default
    if (this.dots.length > 0) {
      this.dots[0].classList.add('active');
    }

    // Setup dot click events
    this.dots.forEach((dot, index) => {
      dot.addEventListener('click', () => this.goToSlide(index));
    });

    // Setup keyboard navigation
    this.addEventListener('keydown', (e) => {
      if (e.key === 'ArrowLeft') {
        this.goToSlide(Math.max(0, this.currentSlide - 1));
      } else if (e.key === 'ArrowRight') {
        this.goToSlide(Math.min(this.slideItems.length - 1, this.currentSlide + 1));
      }
    });

    // Set up observer to track visible slides
    const options = {
      root: this.slider,
      threshold: 0.7
    };

    
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const slideIndex = this.slideItems.indexOf(entry.target);
          if (slideIndex !== -1) {
            this.updateActiveDot(slideIndex);
            this.currentSlide = slideIndex;
          }
        }
      });
    }, options);

    this.slideItems.forEach(slide => {
      this.observer.observe(slide);
    });
  }

  updateActiveDot(index) {
    this.dots.forEach(dot => dot.classList.remove('active'));
    if (this.dots[index]) {
      this.dots[index].classList.add('active');
    }
  }

  goToSlide(index) {
    if (index < 0 || index >= this.slideItems.length) return;
    
    this.slideItems[index].scrollIntoView({
      behavior: 'smooth',
      block: 'nearest', 
      inline: 'start'
    });
    
    this.updateActiveDot(index);
    this.currentSlide = index;
  }
}

// Define custom elements
customElements.define('article-slideshow', ArticleSlideshow);
customElements.define('outro-slideshow', OutroSlideshow);
